<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="mdi-file-clock-outline">
        Standing Orders
        <template v-if="development" v-slot:actions>
          <v-btn
            outlined
            color="blue darken-2"
            :to="{ name: 'StandingOrderCreate', params: { newCreate: '1' } }"
          >
            <v-icon left>edit</v-icon>Create Standing Order
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12" v-if="!development">
      <div>This page is currently under development</div>
    </v-col>
    <v-col cols="12" v-else>
      <v-row justify="start" align="start" no-gutters>
        <v-col v-if="loadingOrders" cols="12" lg="12" xs="12">
          <v-card class="mx-auto" outlined height="100%" loading>
            <v-card-title>Loading Standing Orders...</v-card-title>
            <template slot="progress">
              <v-progress-linear
                color="blue darken-2"
                indeterminate
              ></v-progress-linear>
            </template>
          </v-card>
        </v-col>
        <v-col v-else cols="12" lg="12" xs="12">
          <v-card v-if="standingOrders.length == 0" color="background" flat>
            <v-card-title>You currently have no Standing Orders</v-card-title>
          </v-card>

          <v-card
            v-else
            class="mb-4"
            outlined
            v-for="order in standingOrders"
            :key="order.id"
            @click="setSelected(order)"
          >
            <v-row justify="start" align="center">
              <v-col cols="6">
                <v-card-title v-if="order.trolly_header_info.name"
                  >{{ capitalizeString(order.trolly_header_info.name) }}
                  <v-chip
                    color="success"
                    text-color="white"
                    label
                    class="ml-2"
                    v-if="order.enabled == 1"
                  >
                    <v-avatar left>
                      <v-icon>mdi-checkbox-marked-circle</v-icon>
                    </v-avatar>
                    Active
                  </v-chip>
                </v-card-title>

                <v-card-subtitle>
                  <span v-if="order.trolly_header_info.order_date">
                    Start Date :
                    {{ formatStartDate(order.trolly_header_info.order_date) }}
                  </span>
                </v-card-subtitle>
              </v-col>

              <v-col cols="6">
                <v-card-title>
                  <div v-for="day in days" :key="day">
                    <v-chip
                      v-if="order[day] == 1"
                      class="ma-2"
                      color="green"
                      text-color="white"
                      >{{ capitalizeString(day) }}</v-chip
                    >
                  </div>
                </v-card-title>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";

import { mapActions } from "vuex";
export default {
  name: "StandingOrders",
  data() {
    return {
      development: false,
      loadingOrders: false,
      days: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
    };
  },

  methods: {
    ...mapActions([
      "getStandingOrders",
      "setSnackbar",
      "setSelectedStandingOrder",
      "clearSelectedStandingOrder",
    ]),
    ...mapActions("standingOrderSearch", ["clearGroups", "clearProducts"]),
    setSelected(ord) {
      this.clearSelectedStandingOrder();
      this.clearProducts();
      this.clearGroups();
      this.setSelectedStandingOrder(ord);
      this.$router.push({ name: "StandingOrderProducts" });
    },

    capitalizeString(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    formatStartDate(date) {
      return date ? moment(date).format("dddd, Do MMMM YYYY") : "";
    },
  },

  computed: {
    standingOrders() {
      return this.$store.getters.retrieveAllStandingOrders;
    },

    activeStandingOrder() {},
  },

  async activated() {
    //When Activated we want to refresh our standing orders

    this.loadingOrders = true;

    let standingOrdersResponse = await this.getStandingOrders();
    this.clearSelectedStandingOrder();

    if (!standingOrdersResponse) {
      this.setSnackbar({
        color: "error",
        text: "Error finding standing orders",
      });
    }
    this.loadingOrders = false;
  },
};
</script>
<style lang="sass" scoped>
</style>